import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';

const mouseScroll = keyframes`
	from {
    opacity: 1;
		top: 0;
	}

	to {
    opacity: .5;
		top: 12px;
	}
`;

const ScrollIndicator = styled.button`
  background-color: transparent;
  border-color: ${props =>
    props.inverse ? props.theme.white : props.theme.black};
  border-style: solid;
  border-width: 1px;
  border-radius: 0.65rem;
  cursor: pointer;
  display: inline-block;
  height: 30px;
  position: relative;
  width: 18px;

  &:before {
    animation: ${mouseScroll} 1.5s ease-in-out infinite;
    color: ${props => (props.inverse ? props.theme.white : props.theme.black)};
    content: '.';
    left: 50%;
    line-height: 3px;
    position: absolute;
    top: 0;
    transform: translateX(-50%);
  }

  &:hover,
  &:focus {
    background-color: ${props => props.theme.main};
    border-color: ${props => props.theme.main};
  }
`;

export default props => (
  <ScrollIndicator {...props} title="Scroll To Next Page" />
);



// WEBPACK FOOTER //
// ./src/components/ScrollIndicator.js